// @ts-ignore
/* eslint-disable */
import { apiProxy, apiUrl } from './index';
import { request } from '@umijs/max';

export async function fetchBranches(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.branches}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchDepts(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.depts}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchDeptCameras(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.deptCameras}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchScenes(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.scenes}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchAIServers(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.aiServers}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchLicenseDetail() {
  return request<Record<string, any>>(`/xfx-api${apiUrl.license}`, {
    method: 'GET',
  });
}

export async function fetchFlowStatistics(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.flowStatistics}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchRegionStatistics(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.regionStatistics}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchLatestRegionStatistics(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.latestRegionStatistics}`, {
    method: 'GET',
    ...(options || {}),
  });
}
